module.exports = __webpack_public_path__ + "static/media/Helen.8d06f333.jpg";